// extracted by mini-css-extract-plugin
module.exports = {"container":"_4e3f77bc","title":"_68f58b1e","link":"_9136ddd3","icon":"_c0422b99"};